export default class UtilsService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }
    downloadApiDoc() {
        return this._http.get('utils/api-doc');
    }
}
